export default {

  async collect ({ commit, rootState }, {
    action,
    productEntityId
  }) {
    const route = this.app?.context?.route
    const fullPath = route?.fullPath
    const customerId = rootState?.customer?.customer?.customerId
    const uuid = this.$cookies?.get('cm24-uuid')

    if (customerId == null && uuid == null) { return }

    try {
      await this.$axios.post('/public/user-action-log/collect', {
        action,
        context: fullPath,
        customer_id: customerId,
        uuid,
        product_entity_id: productEntityId
      }, { withCredentials: true })
    } catch (e) {
      console.error(e)
    }
  }

}
